export const LOAD_ANSWERS = 'LOAD_ANSWERS';
export const LOAD_ANSWER = 'LOAD_ANSWER';
export const CREATE_ANSWER = 'CREATE_ANSWER';
export const UPDATE_ANSWER = 'UPDATE_ANSWER';
